import { ButtonBase } from "@mui/material";
import { Popover } from "antd";
import { useState } from "react";

const GuarantorSwitchBox = (props) => {
    const { tabs,handler } = props;
    const [tabIdx, setTabIdx] = useState(0);
    const handleSwitch = (idx) => {
        setTabIdx(idx);
        if(handler){
            handler(idx)
        }
    }

    return (
        <div className={`switch_tab mr-[20px] mb-[15px] inline-block p-[10px_0px] `}>
            <div className="rounded-[4px] bg-[#F5F5F5] p-[3px] flex">
                {
                    tabs.map((tab, idx) => {
                        return (
                            <ButtonBase key={idx}>
                                <span className={`switch ${tabIdx === idx && 'active'}`} onClick={() => handleSwitch(idx)} >{tab.name}</span>
                            </ButtonBase>
                        )
                    })
                }
            </div>
        </div>
    )
};

export default GuarantorSwitchBox;
